/**
 *	city-district-select.serv.js
 */

class CityDistrictSelectServ {

    constructor($http, apiServ) {
        this.$http = $http;
        this.apiServ = apiServ;
    }
    
    getCitiesByDistrict() {
        return this.$http.get(this.apiServ.readUrl('citiesByDistrict'));
    }
}

CityDistrictSelectServ.$inject = ['$http', 'apiServ'];

export default CityDistrictSelectServ;